// extracted by mini-css-extract-plugin
export default {"mobileHeader":"PLuHhGqBMLM_CJjeVDId","scrollMenu":"Sa9k5AdCxmocSLydDK0c","active":"wPAqZeRi3gMKKBsr2TgP","mobileHeaderContainer":"snNDNB3RZVIPgLLIm8kr","logo":"AHpxKIzln5Er_NdBZfjs"};